export default {
  path: '/store-card-record',
  meta: {
    title: '核销记录',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/store-card-record`),
}



// WEBPACK FOOTER //
// ./src/views/StoreCardRecord/router.js